<template lang="pug">
  //- form
  form(@submit.prevent="handleSubmit(value)")
    el-input(
      :placeholder="placeHolder",
      @input="geraEvento",
      :value="value"
    )
      template(slot="append")
        el-button.no-hover(
          slot="append",
          icon="el-icon-search"
        )
</template>

<script>
export default {

  props: {
    value: {
      type: String
    },
    placeHolder: {
      type: String,
      default: 'Informe o Nome',
      required: false
    }
  },

  methods: {
    geraEvento (newValue) {
      this.$emit('input', newValue)
    },
    handleSubmit () {
      this.geraEvento(this.value)
    }
  }

}
</script>

<style lang="scss" scoped>

  .no-hover:hover {
    cursor: auto;
  }

  /deep/ .el-icon-search {
  color: #606266;
}

</style>



// WEBPACK FOOTER //
// src/components/AppSearch.vue